import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import type { CommonalitySubscriptionDeleteResponse } from '@/types/commonality';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../../requestOptions';

export async function deleteSubscriptionCommonality(
  scope: RequestScope,
  args: { subscriptionId: number | string; id: number },
  options: WriteRequestOptions
): Promise<ChannelApiResponse<CommonalitySubscriptionDeleteResponse['data']>> {
  try {
    const res = await scopedChannelApi(scope).delete<CommonalitySubscriptionDeleteResponse>(`atts/commonality/subscription/${args.id}`, {
      ...options,
      headers: buildAsturHeaders({ subscriptionId: args.subscriptionId }),
    });

    if (!res.data?.data) {
      throw new Error('Invalid commonality delete response');
    }

    return {
      data: res.data.data,
      status: res.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
